import sendMessageToParent from "../composables/sendMessageToParent";

(function () {
    console.debug('Widgets loaded');
    let widgetSiteURL = null;
    let apiSiteURL = null;
    if(typeof process !== 'undefined') {
        widgetSiteURL = process.env.MIX_APP_URL;
        apiSiteURL = process.env.MIX_KEAZE_API_BASE_URL;
    }

    if (!widgetSiteURL || !apiSiteURL) {
        if(window.kproDataLayer && window.kproDataLayer.apiUrl && window.kproDataLayer.widgetUrl) {
            widgetSiteURL = window.kproDataLayer.widgetUrl;
            apiSiteURL = window.kproDataLayer.apiUrl;
        } else {
            throw('Widget site URL, or Api URL not found');
        }
    }

    const metaDataFilters = [
        'api-base-url', 'gmap-key', 'portal-id', 'logo-url'
    ];
    const myScript = document.currentScript;
    const queryString = myScript.src.replace(/^[^\?]+\??/,'');
    const params = parseQuery( queryString );
    const portalId = parseInt(params.id);
    const baseAPIUrl = widgetSiteURL + '/portal/' + portalId;
    const locationObj = window.location;
    const pathArray = locationObj.pathname.split('/');
    const availableComponents = ['listing-videos', 'booking-form', 'listing-card-slider', 'login-menu'];

    // get settings
    getSiteSettings(portalId).then((response) => {
        const parsedJSON = JSON.parse(response);
        window.kproDataLayer.settings = parsedJSON.settings;
        let renderType = null;

        renderType = getRenderType();

        if(renderType.length > 0) {
            renderPage();
        } else {
            // No widgets? Dispatch widgetsLoaded event here..
            const widgetsLoaded = new Event('widgetsLoaded');
            window.dispatchEvent(widgetsLoaded);
        }
    });

    function getSiteSettings(id) {
        return new Promise(function(resolve, reject) {
            const url = widgetSiteURL + '/portal/' + id + '/settings';
            const request = new XMLHttpRequest();
            request.open('GET', url, false);

            request.onload = function() {
                if (this.status >= 200 && this.status < 400) {
                    // Success
                    resolve(this.response);
                } else {
                    // Error
                    reject(this.response);
                }
            };

            request.onerror = function() {
                reject(this.response);
            };

            //request.setRequestHeader('Content-Type', 'application/json');
            //request.setRequestHeader('Accept', 'application/json');
            //request.setRequestHeader('Portal-Id', id);
            request.send();
        })
    }

    function getRenderType() {
        let pageType = null;
        let pageContains = [];
        const componentsInPage = document.querySelectorAll(availableComponents.join(", "));
        if (componentsInPage.length > 0) {
            pageContains.push('components');
        }
        pageType = Object.keys(window.kproDataLayer.settings.urls).find((key) => {
            if (key !== 'root') {
                if (window.kproDataLayer.settings.urls[key].length === 0) {
                    return false;
                }
                const urlSetting = new URL(window.kproDataLayer.settings.urls[key]);
                const urlSettingPathArray = urlSetting.pathname.split('/');

                if (arrayEquals(urlSettingPathArray, pathArray)) {
                    return true;
                } else {
                    const difference = urlSettingPathArray.filter(x => !pathArray.includes(x));
                    if (difference[0] == '%7Bslug%7D') {
                        return true;
                    }
                    if (difference[0] == '%7Bid%7D') {
                        return true;
                    }
                    if (difference[0] == '%7Bid%7D' && difference[1] == '%7Btoken%7D') {
                        return true;
                    }
                }
            }
        });
        if (pageType) {
            pageContains.push('fullPage');
        }
        return pageContains;
    }


    function renderPage() {
        const params = [];
        if (window.kproDataLayer.settings.urls.root == locationObj.origin) {
            const pageType = Object.keys(window.kproDataLayer.settings.urls).find((key) => {
                if (key !== 'root') {
                    if (window.kproDataLayer.settings.urls[key].length === 0) {
                        return false;
                    }
                    const urlSetting = new URL(window.kproDataLayer.settings.urls[key]);
                    const urlSettingPathArray = urlSetting.pathname.split('/');

                    if (arrayEquals(urlSettingPathArray, pathArray)) {
                        return true;
                    } else {
                        const difference = urlSettingPathArray.filter(x => !pathArray.includes(x));
                        const invDifference = pathArray.filter(x => !urlSettingPathArray.includes(x));

                        if (difference[0] == '%7Bid%7D' && difference[1] == '%7Btoken%7D') {
                            params.push(invDifference[0]);
                            params.push(invDifference[1]);
                            return true;
                        } else if ((urlSettingPathArray.length == pathArray.length) && (difference[0] == '%7Bslug%7D' || difference[0] == '%7Bid%7D')) {
                            params.push(invDifference);
                            return true;
                        }

                    }
                }
            });
            let url = '';
            if (pageType) {
                url = getAPIUrlFromPageType(pageType, params);
            } else {
                url = getAPIUrlFromPageType('layout');
            }

            getWidgetContent(url).then((response) => {
                setParentMetaData(response, metaDataFilters);
                setParentCss(response);
                setParentScripts(response);
                injectDom(response);
            })
        } else {
            // Error URL's not match
            throw('RootURL and origin URL mismatch');
        }
    }

    function getAPIUrlFromPageType(pageType, params= []) {
        let url = baseAPIUrl;
        switch (pageType) {
            case 'layout':
                url = url + '/layout';
                break;
            case 'login':
                url = url + '/login';
                break;
            case 'register':
                url = url + '/register';
                break;
            case 'forgotPasswordEmail':
                url = url + '/forgot-password-email';
                break;
            case 'forgotPasswordChange':
                url = url + '/forgot-password/' + params[0] + '/' + params[1];
                break;
            case 'emailVerification':
                url = url + '/email-verification/' + params[0] + '/' + params[1];
                break;
            case 'dashboard':
                url = url + '/dashboard';
                break;
            case 'search':
                url = url + '/search';
                break;
            case 'listing':
                url = url + '/listing/' + params[0];
                break;
            case 'applicationForm':
                url = url + '/apply/' + params[0];
                break;
            case 'editApplicationForm':
                url = url + '/application-form/edit/' + parseInt(params[0]);
                break;
            case 'viewApplicationForm':
                url = url + '/application-form/view/' + parseInt(params[0]);
                break;
            default:
                throw('URL not found');
                break;
        }
        return url;
    }

    function getWidgetContent(url) {
        return new Promise(function(resolve, reject) {
            const request = new XMLHttpRequest();
            request.open('GET', url, true);

            request.onload = function() {
                if (this.status >= 200 && this.status < 400) {
                    // Success
                    resolve(this.response);
                } else {
                    // Error
                    reject(this.response);
                }
            };

            request.onerror = function() {
                reject(this.response);
            };
            request.setRequestHeader('Accept', 'text/html');
            request.send();
        });
    }

    function injectDom(documentSource, querySelectorToAppend = '#keaze-frame') {
        const appendDiv = document.querySelector(querySelectorToAppend);
        const domParser = new DOMParser();
        const htmlString = documentSource;
        const docElement = domParser.parseFromString(htmlString, "text/html");
        const widgetContent = docElement.getElementById("widget-app");

        widgetContent.removeAttribute('id');
        widgetContent.classList.remove("widget-application");

        let wrapperDiv = document.createElement("div");
        wrapperDiv.id = "widget-app";
        wrapperDiv.classList.add("widget-application");

        let vuetifyApp = document.createElement("v-app");
        wrapperDiv.appendChild(vuetifyApp);

        let body = document.querySelector('body > *');
        let clone = body.cloneNode(true);
        vuetifyApp.appendChild(clone);

        let scripts = wrapperDiv.getElementsByTagName("script");

        let i = scripts.length;
        while (i--) {
            if(scripts[i].src.indexOf('keaze-widgets.js?id=') > 0) {
                scripts[i].parentNode.removeChild(scripts[i]);
            } else {
                scripts[i].type = 'application/javascript';
            }
        }

        if (widgetContent && appendDiv) {
            const appendDivNew = wrapperDiv.querySelector(querySelectorToAppend);
            appendDivNew.appendChild(widgetContent);
        }

        document.body.innerHTML = '';
        document.body.appendChild(wrapperDiv);
    }

    function setParentScripts(documentSource) {
        const domParser = new DOMParser();
        const htmlString = documentSource;
        const docElement = domParser.parseFromString(htmlString, "text/html").documentElement;
        const scriptCollection = docElement.getElementsByTagName("script");
        for(let a = 0; a < scriptCollection.length ; a++) {
            if(scriptCollection[a].src !== '') {
                const newScript = document.createElement('script');
                newScript.src = scriptCollection[a].src;
                document.getElementsByTagName('body')[0].appendChild(newScript);
            } else {
                const newScript = document.createElement('script');
                newScript.innerHTML = scriptCollection[a].innerHTML;
                document.getElementsByTagName('head')[0].appendChild(newScript);
            }
        }
    }

    function setParentCss(documentSource) {
        const domParser = new DOMParser();
        const htmlString = documentSource;
        const docElement = domParser.parseFromString(htmlString, "text/html").documentElement;
        const cssCollection = docElement.getElementsByTagName("link");
        const styleCollection = docElement.getElementsByTagName("style");
        for(let a = 0; a < cssCollection.length ; a++) {
            if(cssCollection[a].rel == 'stylesheet') {
                const newCss = document.createElement('link');
                newCss.href = cssCollection[a].href;
                newCss.rel = cssCollection[a].rel;
                document.getElementsByTagName('head')[0].appendChild(newCss);
            }
        }
        for(let a = 0; a < styleCollection.length ; a++) {
            if(cssCollection[a].rel == 'stylesheet') {
                const newStyleElement = document.createElement('style');
                newStyleElement.innerHTML = styleCollection[a].innerHTML;
                document.getElementsByTagName('head')[0].appendChild(newStyleElement);
            }
        }
    }

    function setParentMetaData(documentSource, filters) {
        const domParser = new DOMParser();
        const htmlString = documentSource;
        const docElement = domParser.parseFromString(htmlString, "text/html").documentElement;
        const metaCollection = docElement.getElementsByTagName("meta");
        for(let a = 0; a < metaCollection.length ; a++) {
            if(filters.includes(metaCollection[a].name)) {
                const newMeta = document.createElement('meta');
                newMeta.name = metaCollection[a].name;
                newMeta.content = metaCollection[a].content;
                document.getElementsByTagName('head')[0].appendChild(newMeta);
            }
        }
    }

    function parseQuery ( query ) {
        const Params = new Object();
        if ( ! query ) return Params; // return empty object
        const Pairs = query.split(/[;&]/);
        for (let i = 0; i < Pairs.length; i++ ) {
            const KeyVal = Pairs[i].split('=');
            if ( ! KeyVal || KeyVal.length != 2 ) continue;
            const key = unescape(KeyVal[0]);
            let val = unescape(KeyVal[1]);
            val = val.replace(/\+/g, ' ');
            Params[key] = val;
        }
        return Params;
    }

    function arrayEquals(a, b) {
        return Array.isArray(a) &&
            Array.isArray(b) &&
            a.length === b.length &&
            a.every((val, index) => val === b[index]);
    }
})()





window.addEventListener('message', event => {
    //if (event.origin.startsWith('https://test.widgets.keaze') || event.origin.startsWith('https://demo.widgets.keaze')) {
        if(event.data.type == 'modifyPageTitle') {
            document.title = event.data.value;
        } else if (event.data.type == 'modifyPageMetaDescription') {
            if(document.querySelector('meta[name="description"]')) {
                document.querySelector('meta[name="description"]').setAttribute("content", event.data.value);
            }
        } else if (event.data.type == 'modifyPageMetaKeywords') {
            if(document.querySelector('meta[name="keywords"]')) {
                document.querySelector('meta[name="keywords"]').setAttribute("content", event.data.value);
            }
        } else if (event.data.type == 'urlChangedTo') {
            console.debug('url changed to:')
            console.debug(event);
        } else if (event.data.type == 'setHeight') {
            console.debug('Set height to:')
            console.debug(event.data.value);
            //document.getElementById('keaze-frame').style.height = event.data.value + 'px';
        } else if (event.data.type == 'session') {
            console.debug('session:')
            console.debug(event.data.value);
        }

    //}
});

function waitForElement(hash) {
    return new Promise(resolve => {
        if (document.querySelector(hash)) {
            return resolve(document.querySelector(hash));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(hash)) {
                resolve(document.querySelector(hash));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

if (window.top.location.hash) {
    waitForElement(window.top.location.hash).then((elm) => {
        elm.scrollIntoView();
    });
}
